import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "./Loader.module.scss"; // Change to `.module.scss` for CSS Modules

export default function Loader({ message = "Loading...", fullscreen = true }) {
  return (
    <div
      className={`${styles.loadingContainer} ${
        fullscreen ? styles.fullscreen : ""
      }`}
    >
      <CircularProgress color="primary" />
      {message && <div className={styles.loadingText}>{message}</div>}
    </div>
  );
}
